<template>
	<lcsj-dialog v-model="showDialog" title="销售订单详情" width="80%" @close="closeDialog" cancel-text="关闭">
		<detail ref="detail"></detail>
		
	</lcsj-dialog>
</template>
<script>
import detail from "@/views/product/sales/detail.vue";
export default {
	props: [],
	data() {
		return {
			showDialog: false
		};
	},
	components: {
		detail
	},
	created() {},
	methods: {
		// 显示
		getDetailDialog(row) {
			this.showDialog = true;
			this.$nextTick(() => {
				this.$refs.detail.getDetail(row);
			});
		},
		// 关闭
		closeDialog() {
			this.showDialog = false;
		}
	}
};
</script>
<style scoped lang="scss"></style>
